import {WidgetDataRetentionAndDeletionV0ResponseDto} from './models/widget-data-retention-and-deletion-v0-response.dto';
import {
  WidgetDataRetentionAndDeletionV0PreviewValueDto
} from './models/widget-data-retention-and-deletion-v0-preview-value.dto';

export class WidgetDataRetentionAndDeletionV0Utils {

  static queryResponseToDataRetentionAndDelentionValue(queryResponse: unknown[], mapping: {}): WidgetDataRetentionAndDeletionV0ResponseDto[] {
    const keys = Object.keys(mapping);
    const response: WidgetDataRetentionAndDeletionV0ResponseDto[] = [];
    queryResponse.forEach((q: unknown) => {
      const obj = {};
      keys.forEach((outputKey: string) => {
        obj[outputKey] = q[mapping[outputKey]];
      });
      response.push(obj as WidgetDataRetentionAndDeletionV0ResponseDto);
    });
    return response;
  }

  static getValidValue(widgetValue: WidgetDataRetentionAndDeletionV0PreviewValueDto[], data: WidgetDataRetentionAndDeletionV0ResponseDto[]) {
    const validValue = [];

    widgetValue.forEach(currentSavedValue => {
      if (data?.find((r) => r.uuid === currentSavedValue.category)) {
        validValue.push(currentSavedValue);
      }
    });

    return validValue;

  }
}
